// extracted by mini-css-extract-plugin
export default {"container":"yesno_container__B9XIR","button":"yesno_button__YHq3H"};